import { ToastProvider } from '@gymcoach/ui';
import { QueryClientProvider } from '@tanstack/react-query';
import { useState } from 'react';
import { RouterProvider } from 'react-router-dom';

import { AuthProvider } from '@/auth/AuthProvider';
import { createQueryClient } from '@/lib/queryClient';
import { createRouter } from '@/routes/router';
import { ThemeProvider } from '@/shell/theme';

/** Providers, outermost first: data cache → theme → session → toasts → routes. */
export function App() {
  const [queryClient] = useState(createQueryClient);
  const [router] = useState(createRouter);

  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <AuthProvider>
          <ToastProvider>
            <RouterProvider router={router} />
          </ToastProvider>
        </AuthProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
}
